import { CardPresentation } from '@yleisradio/areena-types';

export const isOnDemandCard = (presentation: CardPresentation | undefined) =>
  presentation === 'onDemandCard';

export const isLinkCard = (presentation: CardPresentation | undefined) =>
  presentation === 'linkCard';

export const isPackageCard = (presentation: CardPresentation | undefined) =>
  presentation === 'packageCard';

export const isDetailsCard = (presentation: CardPresentation | undefined) =>
  presentation === 'detailsCard';

export const isSeriesCard = (presentation: CardPresentation | undefined) =>
  presentation === 'seriesCard';

export const isScheduleCard = (presentation: CardPresentation | undefined) =>
  presentation === 'scheduleCard';

export const isListCard = (presentation: CardPresentation | undefined) =>
  presentation === 'listCard';

export const isPlayerCard = (presentation: CardPresentation | undefined) =>
  presentation === 'playerCard';

export const isEpisodeCard = (presentation: CardPresentation | undefined) =>
  presentation === 'episodeCard';

export const isBroadcastCard = (presentation: CardPresentation | undefined) =>
  presentation === 'broadcastCard';
